<template>
  <div>
    <div :style="`transform: rotate(${degs}deg)`" class="compass">
      <div class="compass__inner">
        <div class="compass__data" :style="`transform: rotate(-${degs}deg)`">
          <span>{{ angleToLetter }}</span>
        </div>
      </div>
    </div>
    <div>
      <input
        class="range-input"
        type="range"
        min="0"
        max="360"
        v-model="degs"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialDegs: {
      type: Number,
      default: 0
    }
  },
  watch: {
    degs(newDegs, oldDegs) {
      this.$emit('angleChange', parseInt(newDegs))
    }
  },
  computed: {
    angleToLetter() {
      const angle = this.degs
      if (angle <= 22.5) {
        return 'N'
      } else if (angle <= 67.5) {
        return 'NE'
      } else if (angle <= 112.5) {
        return 'E'
      } else if (angle <= 157.5) {
        return 'SE'
      } else if (angle <= 202.5) {
        return 'S'
      } else if (angle <= 247.5) {
        return 'SW'
      } else if (angle <= 292.5) {
        return 'W'
      } else if (angle <= 337.5) {
        return 'NW'
      } else if (angle <= 360) {
        return 'N'
      }
      return ''
    }
  },
  data() {
    return {
      degs: 0
    }
  },
  mounted() {
    this.degs = this.initialDegs
  }
}
</script>

<style scoped>
.compass {
  width: 100px;
  height: 100px;
  border: 1px solid #fefbf5cc;
  border-radius: 50%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.compass__inner {
  width: 90px;
  height: 90px;
  border-radius: 50%;

  border: 3px solid white;
  display: inline-block;
  min-width: 4em;
  min-height: 4em;
  padding: 0.5em;
  border-radius: 50%;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}

.compass__data {
  color: white;
  font-size: 16px;
}

.range-input {
  margin-top: 24px;
  width: 100%;
}
</style>
